module.exports = __webpack_public_path__ + "static/media/flowers_12.294778b4.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_12.csv
// module id = 751
// module chunks = 0